import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ChatBar from './ChatBar';

export default function PageShell({ children, wide = false }) {
  return (
    <div className="page">
      <Header />
      <div className="site-content">
        <main className={`content-box ${wide ? 'content-box--wide' : ''}`}>{children}</main>
      </div>
      <Footer />
      <ChatBar />
    </div>
  );
}

export function PageTitle({ title, lead, crumbs }) {
  return (
    <header className="entry-header">
      {crumbs ? (
        <p className="crumbs">
          <Link to="/">Home</Link>
          {crumbs.map((crumb) => (
            <span key={crumb.label}>
              <span aria-hidden="true"> › </span>
              {crumb.to ? <Link to={crumb.to}>{crumb.label}</Link> : <span>{crumb.label}</span>}
            </span>
          ))}
        </p>
      ) : null}
      <h1 className="entry-title">{title}</h1>
      {lead ? <p className="entry-lead">{lead}</p> : null}
    </header>
  );
}

/** Backwards-compatible alias used by older pages */
export const PageHero = PageTitle;
